import { Box, Button, Divider, Grid, Paper, Stack } from "@mui/material";
import React, { useState } from "react";
import AccordionComponent from "./AccordionComponent";
import PaginationComponent from "./PaginationComponent";
import FilterTabs from "./FilterTabs";
import { Icon } from "@iconify/react/dist/iconify.js";
import NoDataFound from "../../../components/NodataIndication/NoDataFound";
import { GoalSkeleton } from "./SkeletonDesigns";
import {
  getAllGoals,
  MakeGoalApprovalRequest,
  singleOrBulkArchiveUnarchive,
} from "../../../redux/features/appraisalSlice";

const LeftSection = ({
  data = { data: [], meta: {} },
  loading = true,
  api,
  dispatchData,
  selectedGoalIds,
  setSelectedGoalIds,
  expandedGoalsIds,
  setExpandedGoalsIds,
  tabOptions,
  selectedTabId,
  SetSelectedTabId,
  goalStatusFilterTabLoading,
  dispatch,
  enqueueSnackbar,
  adminView,
  user
}) => {
  const allGoalIds = Array.isArray(data?.data)
    ? data.data.map((goal) => goal?.goal_id)
    : [];
  const isAllSelected = selectedGoalIds.length === allGoalIds.length;
  const isAllExpanded = expandedGoalsIds.length === allGoalIds.length;

  const toggleSelectAll = () => {
    setSelectedGoalIds(isAllSelected ? [] : allGoalIds);
  };
  const toggleExpandAll = () => {
    setExpandedGoalsIds(isAllExpanded ? [] : allGoalIds);
  };
  const isAnyArchivedDataComes = Array.isArray(data?.data)
    ? data?.data.some((goal) => goal?.goal_status == 0)
    : false;

  const bulkOrSingleArchive = ({ ids, action, archive }) => {
    // actions are bulk and single
    const data = { ids: ids, archive: archive };
    dispatch(singleOrBulkArchiveUnarchive(data)).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, {
          variant: "success",
        });
        if (action == "bulk") {
          setSelectedGoalIds([]);
        }
        dispatch(getAllGoals(dispatchData));
      } else {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
      }
    });
  };

  const bulkOrSingleGetApproval = ({ ids, action }) => {
    dispatch(MakeGoalApprovalRequest(ids)).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, {
          variant: "success",
        });
        dispatch(getAllGoals(dispatchData));
      } else {
        enqueueSnackbar(res.payload.message, {
          variant: "error",
        });
      }
    });
  };

  return (
    <Box>
      <Paper
        elevation={6}
        // sx={{
        //   minHeight: "450px",
        // }}
      >
        {/* SCROLLABLE TABS FILTER VIEW START >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
        <Box sx={{ px: 1, pt: 1 }}>
          <FilterTabs
            options={tabOptions}
            selected={selectedTabId}
            onChange={SetSelectedTabId}
            goalStatusFilterTabLoading={goalStatusFilterTabLoading}
          />
        </Box>
        {/* SCROLLABLE TABS FILTER VIEW START <<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Divider sx={{ my: 1 }} />

        <Box>
          {loading ? (
            <GoalSkeleton count={5} />
          ) : data.data.length ? (
            <>
              <Box sx={{ px: "9px" }}>
                {/* ACCORDION ABOVE BUTTONS LIKE SELECT ALL EXPAND ALL AND OTHER START >>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
                <Box
                  display="flex"
                  flexWrap="wrap"
                  sx={{
                    justifyContent: { sm: "flex-start" },
                    gap: { sm: 2, xs: 1 },
                  }}
                  alignItems="center"
                >
                  <Button
                    sx={{
                      minWidth: "130px",
                      fontSize: "0.65rem",
                      borderRadius: "4px",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "primary.main",
                        color: "white",
                      },
                    }}
                    variant={isAllSelected ? "contained" : "outlined"}
                    color="primary"
                    onClick={toggleSelectAll}
                    size="small"
                    startIcon={<Icon icon="mdi:checkbox-marked-outline" />}
                  >
                    {isAllSelected ? "Unselect All" : "Select All"}
                  </Button>

                  <Button
                    sx={{
                      minWidth: "130px",
                      fontSize: "0.65rem",
                      borderRadius: "4px",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "primary.main",
                        color: "white",
                      },
                    }}
                    variant={isAllExpanded ? "contained" : "outlined"}
                    color="primary"
                    onClick={toggleExpandAll}
                    size="small"
                    startIcon={<Icon icon="mdi:arrow-expand" />}
                  >
                    {isAllExpanded ? "Collapse All" : "Expand All"}
                  </Button>

                  <Button
                    disabled={
                      !selectedGoalIds.length || dispatchData.archiveViewChecked
                    }
                    sx={{
                      display: isAnyArchivedDataComes ? "none" : "inline-flex",
                      minWidth: "130px",
                      fontSize: "0.65rem",
                      borderRadius: "4px",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "primary.main",
                        color: "white",
                      },
                    }}
                    variant={"outlined"}
                    color="primary"
                    onClick={() =>
                      bulkOrSingleArchive({
                        ids: selectedGoalIds,
                        action: "bulk",
                        archive: true,
                      })
                    }
                    size="small"
                    startIcon={<Icon icon="ic:sharp-archive" />}
                  >
                    Archive
                  </Button>

                  <Button
                    disabled={
                      !selectedGoalIds.length ||
                      !dispatchData.archiveViewChecked
                    }
                    sx={{
                      display: !isAnyArchivedDataComes ? "none" : "inline-flex",
                      minWidth: "130px",
                      fontSize: "0.65rem",
                      borderRadius: "4px",
                      boxShadow: "none",
                      "&:hover": {
                        bgcolor: "primary.main",
                        color: "white",
                      },
                    }}
                    variant={"outlined"}
                    color="primary"
                    onClick={() =>
                      bulkOrSingleArchive({
                        ids: selectedGoalIds,
                        action: "bulk",
                      })
                    }
                    size="small"
                    startIcon={<Icon icon="ic:sharp-unarchive" />}
                  >
                    UnArchive
                  </Button>
                </Box>
              </Box>
              {/* ACCORDION ABOVE BUTTONS LIKE SELECT ALL EXPAND ALL AND OTHER  END<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
              {/* ACCORDION COMPONENT MAPPING AND CALLING FROM HERE START >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/}
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 1, p: 1 }}
              >
                {data?.data.map((goal, index) => (
                  <AccordionComponent
                    key={goal?.goal_id}
                    goal={goal}
                    selectedGoalIds={selectedGoalIds}
                    setSelectedGoalIds={setSelectedGoalIds}
                    expandedGoalsIds={expandedGoalsIds}
                    setExpandedGoalsIds={setExpandedGoalsIds}
                    bulkOrSingleApproveFunction={bulkOrSingleArchive}
                    bulkOrSingleGetApprovalFunction={bulkOrSingleGetApproval}
                    dispatchData={dispatchData}
                    adminView={adminView}
                    user={user}
                  />
                ))}
              </Box>
              {/* ACCORDION COMPONENT MAPPING AND CALLING FROM HERE END <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<*/}
            </>
          ) : (
            <NoDataFound />
          )}
        </Box>

        {/* PAGINATION COMPONENT START >>>>>>>>>>>>>>>>>>>>>>> */}
        <Box sx={{ pb: 1 }}>
          <PaginationComponent
            api={api}
            meta={data?.meta}
            loading={loading}
            otherProps={dispatchData}
            dependencyFields={[selectedTabId]}
          />
        </Box>
        {/* PAGINATION COMPONENT END <<<<<<<<<<<<<<<<<<<< */}
      </Paper>
    </Box>
  );
};

export default React.memo(LeftSection);

